import { useEffect, useState } from 'react';
import { OFOCodesCategorisationMapper } from './OFOCodesCategorisationsTableColumns';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { defaultObject } from '../../../Helpers/typescriptHelper';
import { useParams } from 'react-router-dom';
import { JobTitles, JobTitlesSearchRequest } from '../../../Component/Model/Dto/WSP/JobTitles';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { Button, Grid, Typography } from '@mui/material';
import { MDBox } from '../../../Component/Common/Components/MDBox';
import { MDAlert } from '../../../Component/Common/Components/MDAlert';
import { WSPImportModal } from '../ImportModal/WSPImportModal';
import { ConfirmationDialog } from '../../../Component/Common/Components/ConfirmationDialog';
import { toast } from 'react-toastify';
import { CreateOfoCodeCategory } from './CreateJobModal/CreateOfoCodeCategory';
import { OfoCodeService } from '../../../Component/Api/OFOCodes/OfoCodeService';
import { DataImportType } from '../../../Component/Model/Enum/BEE123Enums';
import { WSPScorecardService } from '../../../Component/Api/WSPScorecard/WSPScorecardService';

export const OFOCodesCategorisationPage = () => {
    const [jobTitleData, setJobTitleData] = useState<JobTitles[]>(defaultObject);
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [totalItemsCount, setTotalItemsCount] = useState<number>(1);
    const [filteredItemsCount, setfilteredItemsCount] = useState<number>(0);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [isImportModalOpen, setIsImportModalOpen] = useState(false);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
    const [selectedJobTitleId, setSelectedJobTitleId] = useState<number>(0);
    const [selectedJobTitleName, setSelectedJobTitleName] = useState<string>();
    const [organisationName, setOrganisationName] = useState<string>("");
    const [organisationId, setOrganisationId] = useState<number>(0);
    const [openOfoCode, setOpenOfoCode] = useState<boolean>(false);
    const [jobTitleId, setJobTitleId] = useState<number>(0);
    const { WSPScorecardId } = useParams<{ WSPScorecardId: string }>();

    const openModal = () => {
        setOpenOfoCode(true)
    }

    const closeModal = () => {
        setOpenOfoCode(false);
        setJobTitleId(0);
        fetchData();
    }

    useEffect(() => {
        fetchOrganisation();
    }, []);


    const JobTitlesSearchRequest: JobTitlesSearchRequest = {
        scorecardId: WSPScorecardId,
        organisationId: organisationId,
        searchText: searchValue,
        columnSortOptions: columnSortOptions,
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
    }

    const fetchOrganisation = async () => {
        try {
            let scorecard = await WSPScorecardService.getScorecard(WSPScorecardId);

            if (scorecard.data.id !== undefined) {
                setOrganisationName(scorecard.data.organisationName);
                setOrganisationId(scorecard.data.organisationId);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let wspScorecardsResult = await OfoCodeService.getJobTitles(JobTitlesSearchRequest);

            if (wspScorecardsResult.data != undefined) {
                setJobTitleData(wspScorecardsResult.data.results);
                setTotalItemsCount(wspScorecardsResult.data.totalItemsCount);
                setfilteredItemsCount(wspScorecardsResult.data.filteredItemsCount);
            }
        } catch (error) {
            console.log(error);
            setJobTitleData(defaultObject);
            setTotalItemsCount(1);
        } finally {
            setIsLoading(false);
        }
    };

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    };

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    };

    const entriesPerPageChanged = (entries: number) => {
        setEntriesPerPage({ defaultValue: entries });
        setPageNumber(1);
    };

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setColumnSortOptions([sortOption]);
        setPageNumber(1);
    };

    const closeImportModal = () => {
        setIsImportModalOpen(false);
        fetchData();
    }

    useEffect(() => {
        if(organisationId !== 0) {
            fetchData();
        }
    }, [entriesPerPage, pageNumber, columnSortOptions, searchValue, organisationId]);

    const editOfoCodeRecord = (id: number) => {
        setJobTitleId(id);
        openModal();
    };

    const showDeleteConfirmation = (id: number, jobTitleName: string) => {
        setSelectedJobTitleId(id);
        setSelectedJobTitleName(jobTitleName);
        setShowConfirmationDialog(true);
    };

    const handleDelete = async () => {
        try {
            await OfoCodeService.deleteJobTitle(selectedJobTitleId, WSPScorecardId);
            toast.success(`Successfully deleted Job Title: ${selectedJobTitleName}`);
        } catch (error) {
            console.log(error);
        } finally {
            handleCloseConfirmation();
        }
    };
    const confirmDeleteMessage = `Are you sure you want to delete the Job Title: ${selectedJobTitleName}`;

    const tableData = OFOCodesCategorisationMapper(jobTitleData, editOfoCodeRecord, showDeleteConfirmation);
    const handleCloseConfirmation = () => {
        setShowConfirmationDialog(false);
        fetchData();
    }

    return (
        <>

            <Typography variant="h4" style={{ paddingBottom: "20px" }}>
                OFO Codes Categorisation
            </Typography>
            <Typography variant="body2" style={{ paddingBottom: "20px" }}>
                Upload a list of the job titles for {organisationName}.
            </Typography>
            <Button variant='contained' onClick={() => openModal()}>Capture Job Title</Button>
            {openOfoCode && <CreateOfoCodeCategory open={openOfoCode} closeModal={closeModal} jobTitleId={jobTitleId} organisationId={organisationId} />}
            <DataTable
                table={tableData}
                entriesPerPage={entriesPerPage}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumber={pageNumber}
                pageNumberChanged={pageNumberChanged}
                columnSortingChanged={columnSortingChanged}
                searchValueChanged={searchValueChanged}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                isLoading={isLoading}
                canSearch={true}
                manualSorting={true}
            />

            {isImportModalOpen && <WSPImportModal open={isImportModalOpen} closeModal={closeImportModal} dataImportType={DataImportType.JobTitle} organisationId={organisationId} scorecardId={WSPScorecardId} />}
            <Grid item xs={12} lg={12}>
                <MDBox mt={4} color="white">
                    <MDAlert color='light'>
                        <MDTypography component='span' variant='body' fontSize='0.93rem' fontWeight='regular'>
                            <p style={{ marginBottom: "0.2rem" }}> Click<Button variant="text" onClick={() => {
                                setIsImportModalOpen(true);
                            }} size="small" style={{ fontSize: "inherit", padding: "0.25rem", paddingBottom: "0.4rem", minWidth: "0", textTransform: "none" }}>here</Button>
                                to Import data from a file</p>
                        </MDTypography>
                    </MDAlert>
                </MDBox>
            </Grid>
            <ConfirmationDialog
                showDialog={showConfirmationDialog}
                handleAccept={handleDelete}
                handleCancel={handleCloseConfirmation}
                heading={"Confirm Delete"}
                message={confirmDeleteMessage}
            />
        </>
    )
}
